import styled from 'styled-components'

import DatePicker from "react-datepicker"

// Campo sobre superficie CLARA (fica direto no fundo bege do SchedulingAdd).
export const Container = styled.div`
  width: 85%;
  height: 50px;     
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  border: 1px solid ${({ theme }) => theme.colors.borderField};
  border-radius: 10px;
  color: ${({ theme }) => theme.colors.textPrimary};
  font-size: 14px;
  transition: border-color 0.2s;

  &:focus-within {
    border-color: ${({ theme }) => theme.colors.accent};
  }
`;


export const DatePickerContainer = styled(DatePicker)`
  width: 100%;
  height: 50px;
  background-color: transparent;
  margin: 0;
  padding: 0;
  border: none; 
  padding-left: 16px;
  font-size: 14px;
  color: ${({ theme }) => theme.colors.textPrimary};
  outline: none;
`;
